export default [
    { key: 'accounting', title: __('Accounting & Financial') },
    { key: 'agriculture', title: __('Agriculture') },
    { key: 'animals', title: __('Animal & Pet') },
    { key: 'architectural', title: __('Architectural') },
    { key: 'art', title: __('Art & Design') },
    { key: 'attorney', title: __('Attorney & Law') },
    { key: 'automotive', title: __('Automotive') },
    { key: 'bar', title: __('Bar & Nightclub') },
    { key: 'business', title: __('Business & Consulting') },
    { key: 'children', title: __('Childcare') },
    { key: 'cleaning', title: __('Cleaning & Maintenance') },
    { key: 'communications', title: __('Communications') },
    { key: 'community', title: __('Community & Non-Profit') },
    { key: 'computer', title: __('Computer') },
    { key: 'construction', title: __('Construction') },
    { key: 'cosmetics', title: __('Cosmetics & Beauty') },
    { key: 'dating', title: __('Dating') },
    { key: 'education', title: __('Education') },
    { key: 'entertainment', title: __('Entertainment & The Arts') },
    { key: 'environment', title: __('Environmental') },
    { key: 'fashion', title: __('Fashion') },
    { key: 'floral', title: __('Floral') },
    { key: 'food', title: __('Food & Drink') },
    { key: 'games', title: __('Games & Recreational') },
    { key: 'home', title: __('Home Furnishing') },
    { key: 'industrial', title: __('Industrial') },
    { key: 'internet', title: __('Internet') },
    { key: 'landscaping', title: __('Landscaping') },
    { key: 'medical', title: __('Medical & Pharmaceutical') },
    { key: 'photography', title: __('Photography') },
    { key: 'physical', title: __('Physical Fitness') },
    { key: 'politics', title: __('Political') },
    { key: 'realestate', title: __('Real Estate & Mortgage') },
    { key: 'religious', title: __('Religious') },
    { key: 'restaurant', title: __('Restaurant') },
    { key: 'retail', title: __('Retail') },
    { key: 'security', title: __('Security') },
    { key: 'spa', title: __('Spa & Esthetics') },
    { key: 'sports', title: __('Sport') },
    { key: 'technology', title: __('Technology') },
    { key: 'travel', title: __('Travel & Hotel') },
    { key: 'wedding', title: __('Wedding Service') },
];
